import * as React from 'react'
import Menu from '@mui/material/Menu'
import { useState } from 'react'
import { IconButton, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import { Box } from '@mui/system'
import useStyles from './Styles/useStyles'

export default function ModalMenuItem({
  item,
  onConfigureUser,
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClickButton = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickButton}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          onClose={handleClose}
          onConfigureUser={onConfigureUser}
          item={item}
        />
      </Menu>


    </>
  )
}

function FiltersList({
  onClose,
  onConfigureUser,
  item
}) {
  const classes = useStyles()

  return (
    <Box
      sx={{
        width: 240
      }}
      className={classes.boxStyle}
      onClick={onClose}
    >
      <IconButton
        onClick={() => onConfigureUser(item)}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Configurar acceso a la aplicación
          </Typography>
        </Box>
      </IconButton>

    </Box>
  )
}
